import React from 'react';
import { Navigate, useParams } from 'react-router-dom';

/** 与文献一致：详情路由重定向到共享页并选中文件夹 */
const SharedExperimentNotebookDetail: React.FC = () => {
  const { folderId } = useParams<{ folderId: string }>();
  if (!folderId) {
    return <Navigate to="/workbench/experiment-records/shared" replace />;
  }
  return <Navigate to={`/workbench/experiment-records/shared?folder=${encodeURIComponent(folderId)}`} replace />;
};

export default SharedExperimentNotebookDetail;
